import { createAction, props } from '@ngrx/store';

import { PromotionData, PromotionOverData } from '@features/promotion';
import { ShippingMethod } from '@features/shipping';

export const ShippingActions = {
    LOAD_SHIPPING_METHODS_REQUIREMENTS_SUCESS: '[shipping] LOAD_SHIPPING_METHODS_REQUIREMENTS_SUCESS',
    LOAD_SHIPPING_METHODS: '[shipping] LOAD_SHIPPING_METHODS',
    LOAD_SHIPPING_METHODS_SUCCESS: '[shipping] LOAD_SHIPPING_METHODS_SUCCESS',
    LOAD_SHIPPING_METHODS_ERROR: '[shipping] LOAD_SHIPPING_METHODS_ERROR',
    SET_SELECTED_SHIPPING_METHOD: '[shipping] SET_SELECTED_SHIPPING_METHOD',
    SEND_CHECKOUT_SHIPPING: '[shipping] SEND_CHECKOUT_SHIPPING',
    SEND_CHECKOUT_SHIPPING_SUCCESS: '[shipping] SEND_CHECKOUT_SHIPPING_SUCCESS',
    SEND_CHECKOUT_SHIPPING_ERROR: '[shipping] SEND_CHECKOUT_SHIPPING_ERROR',
    LOAD_SHIPPING_PROMOTIONS: '[shipping] LOAD_SHIPPING_PROMOTIONS',
    LOAD_SHIPPING_PROMOTIONS_SUCCESS: '[shipping] LOAD_SHIPPING_PROMOTIONS_SUCCESS',
    LOAD_SHIPPING_PROMOTIONS_ERROR: '[shipping] LOAD_SHIPPING_PROMOTIONS_ERROR',
    SET_FREE_SHIPPING_OVER_PROMO: '[shipping] SET_FREE_SHIPPING_OVER_PROMO',
    ENABLE_FAST_SINT: '[shipping] ENABLE_FAST_SINT',
    DISABLE_FAST_SINT: '[shipping] DISABLE_FAST_SINT',
    SET_FAST_SINT: '[shipping] SET_FAST_SINT',
};

export const LoadShippingMethodRequirementsSuccess = createAction(
    ShippingActions.LOAD_SHIPPING_METHODS_REQUIREMENTS_SUCESS,
);

export const LoadShippingMethods = createAction(
    ShippingActions.LOAD_SHIPPING_METHODS,
);

export const LoadShippingMethodsSuccess = createAction(
    ShippingActions.LOAD_SHIPPING_METHODS_SUCCESS,
    props<{ values: ShippingMethod[] }>()
);

export const LoadShippingMethodsError = createAction(
    ShippingActions.LOAD_SHIPPING_METHODS_ERROR,
    props<{ error: any }>()
);

export const SetSelectedShippingMethod = createAction(
    ShippingActions.SET_SELECTED_SHIPPING_METHOD,
    props<{ selectedShippingMethod: ShippingMethod }>()
);

export const SendCheckoutShipping = createAction(ShippingActions.SEND_CHECKOUT_SHIPPING);
export const SendCheckoutShippingSuccess = createAction(ShippingActions.SEND_CHECKOUT_SHIPPING_SUCCESS);
export const SendCheckoutShippingError = createAction(
    ShippingActions.SEND_CHECKOUT_SHIPPING_ERROR,
    props<{ error: any; selectedMethod?: ShippingMethod }>()
);

export const SetFreeShippingOverPromo = createAction(
    ShippingActions.SET_FREE_SHIPPING_OVER_PROMO,
    props<{ payload: PromotionOverData }>()
);

export const LoadPromotions = createAction(ShippingActions.LOAD_SHIPPING_PROMOTIONS);
export const LoadPromotionsSuccess = createAction(
    ShippingActions.LOAD_SHIPPING_PROMOTIONS_SUCCESS,
    props<{ payload: PromotionData }>()
);
export const LoadPromotionsError = createAction(ShippingActions.LOAD_SHIPPING_PROMOTIONS_ERROR);
